// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/SearchLoading.gif");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".searchResult-generic{width:100%;height:100%;border-radius:50%;display:flex;justify-content:center;align-items:center;color:#fff;font-weight:800;font-size:18px}.searchResults{flex:1}.searchResults--loading{overflow-y:hidden}.searchResults__loadBar{height:12px;flex:1;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-repeat:repeat-x}", ""]);
// Exports
module.exports = exports;
